import { Navigate, RouteObject } from 'react-router-dom';
import { ForgeLayout } from './components/layout/ForgeLayout';
import { RemoteDataCollectionConfiguration } from './pages/configuration/RemoteDataCollectionConfiguration';
import { DataCollectionDashboard } from './pages/dashboard/DataCollectionDashboard';
import { DesignGroupsDashboard } from './pages/dashboard/DesignGroupsDashboard';
import { DesignsDashboard } from './pages/dashboard/DesignsDashboard';
import { MasterLabelUnresolvedDashboard } from './pages/dashboard/MasterLabelUnresolvedDashboard';
import { ProductRecognitionInferenceDashboard } from './pages/dashboard/ProductRecognitionInferenceDashboard';
import { RemoteDataCollectionDashboard } from './pages/dashboard/RemoteDataCollectionDashboard';
import { SystemHealthDashboard } from './pages/dashboard/SystemHealthDashboard';
import { FORGE_SYSTEM_HEALTH_PATH } from './paths';

export const forgeRoutes: RouteObject = {
  path: '/forge',
  element: <ForgeLayout />,
  children: [
    { index: true, element: <Navigate to={FORGE_SYSTEM_HEALTH_PATH} replace /> },
    // Dashboards
    {
      path: 'dashboards/system-health',
      element: <SystemHealthDashboard />,
    },
    {
      path: 'dashboards/pr-inference-okrs',
      element: <ProductRecognitionInferenceDashboard />,
    },
    {
      path: 'dashboards/designs',
      element: <DesignsDashboard />,
    },
    {
      path: 'dashboards/design-groups',
      element: <DesignGroupsDashboard />,
    },
    // Task lists
    { path: 'task-lists/store-dc', element: <DataCollectionDashboard /> },
    { path: 'task-lists/remote-dc', element: <RemoteDataCollectionDashboard /> },
    { path: 'task-lists/unresolved', element: <MasterLabelUnresolvedDashboard /> },
    // Configuration
    { path: 'configuration/remote-dc', element: <RemoteDataCollectionConfiguration /> },
    // labeler-accessible tool routes are registered at top level in App.tsx.
  ],
};
